import { Page } from "./Page";
import { Wrapper } from "./Wrapper";
import { Section } from "./Section";
import { Group } from "./Group";
import { Column } from "./Column";
import { Text } from "./Text";
import { Button } from "./Button";
import { Image } from "./Image";
import { Spacer } from "./Spacer";
import { Raw } from "./Raw";
import { Mergetag } from "./Mergetag";
import { LineBreak } from "./LineBreak";
import { BasicType } from "@easy-email-pro-core/constants";
import { Social } from "./Social";
import { Navbar } from "./Navbar";
import { Divider } from "./Divider";
import { NavbarLink } from "./NavbarLink";
import { SocialElement } from "./SocialElement";
import { Hero } from "./Hero";
import { Placeholder } from "./Placeholder";
import { HtmlNode } from "./HtmlNode";
import { HtmlDomNode } from "./HtmlDomNode";
import { ContentWidget } from "./ContentWidget";
import { SectionWidget } from "./SectionWidget";
import { WrapperWidget } from "./WrapperWidget";
import { Code } from "./Code";
import { Table } from "./Table";
import { HtmlBlockNode } from "./HtmlBlockNode";
import { PageHeader } from "./PageHeader";
import { PageFooter } from "./PageFooter";

export default {
  [BasicType.PAGE]: Page,
  [BasicType.HERO]: Hero,
  [BasicType.WRAPPER]: Wrapper,
  [BasicType.SECTION]: Section,
  [BasicType.GROUP]: Group,
  [BasicType.COLUMN]: Column,
  [BasicType.TEXT]: Text,
  [BasicType.TABLE]: Table,
  [BasicType.IMAGE]: Image,
  [BasicType.BUTTON]: Button,
  [BasicType.SPACER]: Spacer,
  [BasicType.DIVIDER]: Divider,
  [BasicType.SOCIAL]: Social,
  [BasicType.SOCIAL_ELEMENT]: SocialElement,
  [BasicType.NAVBAR]: Navbar,
  [BasicType.NAVBAR_LINK]: NavbarLink,
  [BasicType.RAW]: Raw,
  [BasicType.MERGETAG]: Mergetag,
  [BasicType.LINE_BREAK]: LineBreak,
  [BasicType.PLACEHOLDER]: Placeholder,
  [BasicType.DANGEROUS_CODE]: Code,
  [BasicType.HTML_NODE]: HtmlNode,
  [BasicType.HTML_BLOCK_NODE]: HtmlBlockNode,
  [BasicType.HTML_DOM_NODE]: HtmlDomNode,
  [BasicType.CONTENT_WIDGET]: ContentWidget,
  [BasicType.SECTION_WIDGET]: SectionWidget,
  [BasicType.WRAPPER_WIDGET]: WrapperWidget,
  [BasicType.PAGE_HEADER]: PageHeader,
  [BasicType.PAGE_FOOTER]: PageFooter,
};
